'use client'

import { Button } from "@/components/elements/Button"
import Input from "@/components/elements/Input"
import { Label } from "@/components/ui/label"
import { formatImageURL } from "@/utils/util"
import { PASSWORD_RULES } from "@/utils/auth"
import { useCustomerSettings, useChangePassword } from "@/lib/commerce/hooks"
import Avatar from "boring-avatars"
import { CircleCheck } from "lucide-react"

export default function Settings({ customer, vendor }: { customer: any, vendor: any }) {
  const {
    firstName, setFirstName, lastName, setLastName, email, phone, setPhone,
    preview, loading, isImageUploaded, inputFile,
    handleFileChange, selectFile, handleSave,
  } = useCustomerSettings(customer)

  const {
    newPassword, setNewPassword, newPasswordConfirm, setNewPasswordConfirm,
    checks, isPasswordLoading, handlePasswordChange,
  } = useChangePassword()

  return (
    <div className="cont py-4 sm:py-8">
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-col gap-1">
          <div className="font-semibold text-lg text-foreground">Тохиргоо</div>
          <div className="text-sm text-muted-foreground">Өөрийн хувийн мэдээллийг засах</div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-6 gap-6 pt-2 mb-4">
          <div className="sm:col-span-3">
            <Input label="Нэр" placeholder="Таны нэр" value={firstName} onChange={(e: any) => setFirstName(e.target.value)} color={vendor?.color?.primary} />
          </div>
          <div className="sm:col-span-3">
            <Input label="Овог" placeholder="Таны овог" value={lastName} onChange={(e: any) => setLastName(e.target.value)} color={vendor?.color?.primary} />
          </div>
          <div className="col-span-full">
            <Label>Зураг</Label>
            <div className="mt-2.5 flex items-center gap-x-4">
              <div className="relative cursor-pointer group" onClick={selectFile}>
                {preview ? (
                  <img src={preview} alt="profile" className="rounded-full w-16 h-16 object-cover border-2 border-primary" />
                ) : customer.avatar ? (
                  <img src={formatImageURL(customer.avatar)} alt="profile" className="rounded-full w-16 h-16 object-cover border-2 border-transparent hover:border-primary transition-colors" />
                ) : (
                  <Avatar size={64} variant="marble" name={customer.email || undefined} className="rounded-full border-2 border-transparent hover:border-primary transition-colors" />
                )}
                <div className="absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-white text-xs font-medium">Солих</span>
                </div>
              </div>
              <Button onClick={selectFile} variant="outline" size="sm" disabled={isImageUploaded}>
                {isImageUploaded ? "Зураг оруулж байна..." : "Зураг оруулах"}
              </Button>
              <input type="file" accept="image/*" ref={inputFile} className="hidden" onChange={handleFileChange} />
            </div>
          </div>
          <div className="sm:col-span-3">
            <Input label="И-мэйл" placeholder="example@shop.mn" value={email} disabled={true} color={vendor?.color?.primary} />
          </div>
          <div className="sm:col-span-3">
            <Input label="Утасны дугаар" placeholder="00000000" value={phone} onChange={(e: any) => setPhone(e.target.value)} color={vendor?.color?.primary} />
          </div>
        </div>
        <div className="flex items-center justify-end">
          <Button onClick={handleSave} isLoading={loading} color={vendor?.color?.primary}>Хадгалах</Button>
        </div>

        <div className="flex flex-col gap-1">
          <div className="font-semibold text-lg text-foreground">Нууц үг солих</div>
          <div className="text-sm text-muted-foreground">Өөрийн нэвтрэх нууц үгийг солих</div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-6 gap-6 pt-2 mb-4">
          <div className="sm:col-span-3">
            <Input label="Шинэ нууц үг" type="password" placeholder="Шинэ нууц үг" value={newPassword} onChange={(e: any) => setNewPassword(e.target.value)} color={vendor?.color?.primary} />
            <div className="mt-4 flex flex-col gap-2">
              {PASSWORD_RULES.map(rule => (
                <div key={rule.key} className="flex gap-2 items-center">
                  <CircleCheck className={`h-4 w-4 ${checks[rule.key] ? 'text-green-500' : 'text-red-500'}`} />
                  <span className="text-sm font-medium text-muted-foreground">{rule.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="sm:col-span-3">
            <Input label="Шинэ нууц үг давтах" type="password" placeholder="Шинэ нууц үг давтах" value={newPasswordConfirm} onChange={(e: any) => setNewPasswordConfirm(e.target.value)} color={vendor?.color?.primary} />
          </div>
        </div>
        <div className="flex items-center justify-end">
          <Button onClick={handlePasswordChange} isLoading={isPasswordLoading} color={vendor?.color?.primary}>Хадгалах</Button>
        </div>
      </div>
    </div>
  )
}
